const csvExtracter = (feed) => {
  // symbol/token,exchange,timestamp,ltp
  const [symbol = '', exchange = '', timestamp = '', ltpRaw = ''] =
    feed.split(',');

  const ltp = typeof Number(ltpRaw) === 'number' ? Number(ltpRaw) : ltp;

  return {
    timestamp,
    exchange,
    symbol,
    ltp,
  };
};

export const updateSymbolLiveFeed = (state, action) => {
  let { data = {} } = state;
  const { data: feed = '' } = action || {};

  if (!feed) {
    return state;
  }

  const { timestamp, exchange, symbol, ltp } = csvExtracter(feed);

  if (!symbol) {
    return state;
  }

  if (!data[symbol]) {
    data[symbol] = {};
  }

  data[symbol] = {
    timestamp,
    exchange,
    symbol,
    ltp,
  };

  return {
    ...state,
    data: data,
  };
};
